import { useEffect, useState } from 'react';

import { useApi } from '@backstage/core-plugin-api';

import { armApiRef } from '../api/ArmApiClient';

export type UserGroups = {
  /** Lower-cased group ids. */
  groupIds: Set<string>;
  loading: boolean;
  error: Error | undefined;
};

/**
 * Resolves the current user's Azure AD security-group memberships (via the
 * common-utils backend). Used to gate KaaP tenant edit/delete actions against a
 * tenant's `spec.tenant.securityObjectIds`, and to filter the tenant list. On
 * failure the set stays empty, so actions remain disabled.
 */
export const useUserGroups = (): UserGroups => {
  const armApi = useApi(armApiRef);
  const [groupIds, setGroupIds] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    let cancelled = false;
    armApi
      .getGroups({ isMember: true })
      .then(groups => {
        if (!cancelled) {
          setGroupIds(new Set(groups.map(g => g.id.toLowerCase())));
        }
      })
      .catch(e => {
        if (!cancelled) {
          setError(e instanceof Error ? e : new Error(String(e)));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [armApi]);

  return { groupIds, loading, error };
};
